import React from "react";
import { useParams } from "react-router-dom";
import { MatchProvider } from "../context/match_context";

import { MatchDetail } from "../components";

const MatchOldPage = () => {
  const { matchId } = useParams();

  return (
    <MatchProvider>
      <MatchDetail matchId={matchId} />
    </MatchProvider>
  );
};

export default MatchOldPage;
